import(/* webpackMode: "eager" */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SafeImage"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/common/SafeImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/MobileBottomNav.jsx");
